import React from "react";
import MainCard from "../../components/Maincard";
import { useGetTokenOrLogout } from "../../utils/token";
import CustomPopup from "../../components/CustomPopup";
import AssignPerCentageForm from "./AssignPerCentageForm";
import { useState } from "react";
import { useEffect } from "react";
import { Button, Grid, Typography } from "@mui/material";
import CustomAutocompleteComp from "../../newTestPrep/newComponent/AutocompleteComp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ClearIcon from "@mui/icons-material/Clear";
import CustomSnackbar from "../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import CustomTextFieldComp from "../../newTestPrep/newComponent/customTextFieldComp";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function AddAutoAssign({onClose}) {
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const [campaignList, setCampaignList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [service, setService] = useState([]);
  const [serviceIds, setServiceIds] = useState([]);
  const [subServiceList, setSubserviceList] = useState([]);
  const [subService, setSubService] = useState([]);
  const [admissionProgramList, setAdmissionProgramList] = useState([]);
  const [admissionProgram, setAdmissionProgram] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchName, setBranchName] = useState([]);
  const [userList, setUserList] = useState([]);
  const [assignTo, setAssignTo] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [percentages, setPercentages] = useState({
  assignment_percentage: [],
});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Fetch campaign list
  useEffect(() => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/ongoing-upcomingevent/${userId}`,
          { headers },
        );
        if (response.ok) {
          const data = await response.json();

          setCampaignList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  //   select campaign
  const handleChangeCampaign = (event, value) => {
    setSelectedCampaign(value);
  };

  //   fetch service
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          setServiceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {}
    };
    fetchData();
  }, []);

  const handleServiceChange = (event, value) => {
    setService(value);
    const selectedids = value.map((i) => i.id);
    setServiceIds(selectedids);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          const subserviceDatalist = data.filter((i) =>
            serviceIds.includes(i.service_id),
          );
          setSubserviceList(subserviceDatalist);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {}
    };
    fetchData();
  }, [serviceIds]);

  const handleSubServiceChange = (event, value) => {
    setSubService(value);
  };

  //   fetch admission program

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice-program`);
        if (response.ok) {
          const data = await response.json();
          let subServiceIds = subService.map((val) => {
            return val.id;
          });
          const admissionProgramDatalist = data.filter((i) =>
            subServiceIds.includes(i.sub_service_id),
          );
          setAdmissionProgramList(admissionProgramDatalist);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {}
    };
    fetchData();
  }, [subService]);

  //   select admission program
  const handleAdmissionProgramChange = (event, value) => {
    setAdmissionProgram(value);
  };

  //   fetch branch
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();
          setBranchList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {}
    };
    fetchData();
  }, []);

  //   select branch
  const handleBranchChange = (event, value) => {
    setBranchName(value);
  };

  //   fetch user
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalluser`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          );
          setUserList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  //   select user

  const handleUserChange = (event, value) => {
    setAssignTo(value);
    // if (value.length > 1) {
    //   handleOpenPopup();
    // }
  };

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };



const handleChangepercentage = (user_id, per) => {
  setPercentages((prev) => {
    // Remove existing entry for the same user if any
    const updatedArray = prev.assignment_percentage.filter(
      (item) => item.user_id !== user_id
    );

    // Add the new/updated value
    updatedArray.push({ user_id, per: Number(per),assigned:0 });

    return {
      ...prev,
      assignment_percentage: updatedArray,
    };
  });
};


  const handleReset = () => {
    setSelectedCampaign(null);
    setService([]);
    setSubService([]);
    setAdmissionProgram([]);
    setBranchName([]);
    setAssignTo([]);
    setPercentages({});
  };



  const handleSubmit = async () => {
    const token = getTokenOrLogout();
    if (!token) return;
     if (!selectedCampaign) return showSnackbar("Please select a campaign", "error");
    if (!service.length) return showSnackbar("Please select a service", "error");
    if (!subService.length) return showSnackbar("Please select a sub service", "error");

    if (!branchName.length) return showSnackbar("Please select a branch", "error");
    if (!assignTo.length) return showSnackbar("Please select a user", "error");
    if (!percentages.assignment_percentage.length) return showSnackbar("Please select a percentage", "error");
    if(!userId) return showSnackbar("Please select a user", "error");

    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const requestData = {
        campaign_id: selectedCampaign?.id,
        service_id: serviceIds,
        sub_service_id: subService.map((i) => i.id),
        admission_program_id: admissionProgram.map((i) => i.id),
        nearest_branch_id: branchName.map((i) => i.id),
        counsellor_id: assignTo.map((i) => i.id),
        assignment_percentage: percentages?.assignment_percentage,
        user_id: parseInt(userId),
      };
      const response = await fetch(`${API_ENDPOINT}leaddistribution`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
    
      if (response.ok) {
        showSnackbar("Leads assigned successfully", "success");

        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }  else {
        showSnackbar(data.message || "Failed to assign leads", "error");
      }
    } catch (error) {
      showSnackbar("Failed to assign leads", "error");
    }
  };

  console.log("percentage", percentages);

  return (
    <>
   
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} >
            <Typography variant="h6">Select Campaign    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span> </Typography>
            <CustomAutocompleteComp
              size="small"
              
              value={selectedCampaign}
              onChange={handleChangeCampaign}
              options={campaignList}
              getOptionLabel={(option) => option?.campaign_name}
            />
          </Grid>

          <Grid item xs={12} sm={6} >
            <Typography variant="h6">Select Service    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span> </Typography>
            <CustomAutocompleteComp
              size="small"
              
              multiple
              value={service}
              onChange={handleServiceChange}
              options={serviceList}
              getOptionLabel={(option) => option.service_name}
              tooltipContent={(option) => option.service_name}
            />
          </Grid>

          {/* Subservice  */}
          {service.length > 0 && (
            <Grid item xs={12} sm={6} >
              <Typography variant="h6">Sub Service    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>

              <CustomAutocompleteComp
                size="small"
                multiple
                
                value={subService}
                onChange={handleSubServiceChange}
                options={subServiceList}
                getOptionLabel={(option) => option.name}
                tooltipContent={(option) => option.name}
              />
            </Grid>
          )}

          {/* Admission program  */}
          {service.length > 0 &&
            subService.length > 0 &&
            subService.find((val) => {
              return [13, 14].includes(val.id);
            }) &&
            service.find((val) => {
              return val.id == 2;
            }) && (
              <Grid item xs={12} sm={6}>
                <Typography variant="h6">Admission Program </Typography>

                <CustomAutocompleteComp
                  size="small"
                  multiple
                  
                  value={admissionProgram}
                  onChange={handleAdmissionProgramChange}
                  options={admissionProgramList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                />
              </Grid>
            )}

          {/* Branch */}

          <Grid item xs={12} sm={6} >
            <Typography variant="h6">Select Nearest Branch     <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
            <CustomAutocompleteComp
              size="small"
              
              multiple
              value={branchName}
              onChange={handleBranchChange}
              options={branchList}
              getOptionLabel={(option) => option?.branch_name}
              tooltipContent={(option) => option?.branch_name}
            />
          </Grid>

          <Grid item xs={12} sm={6} >
            <Typography variant="h6">Select Users    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
            <CustomAutocompleteComp
              size="small"
              
              multiple
              value={assignTo}
              onChange={handleUserChange}
              options={userList}
              getOptionLabel={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
              tooltipContent={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
            />
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
             {assignTo?.map((user) => {
        // Find current value for this user in the array
        const current = percentages.assignment_percentage?.find(
          (item) => item.user_id === user.id
        )?.per;

        return (
          <Grid item xs={12} sm={6} key={user.id}>
            <Typography variant="h5" sx={{ mb: 0.5 }}>
              {user.first_name} {user.last_name}    <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
            </Typography>

            <CustomTextFieldComp
              type="number"
              size="normal"
              fullWidth
              placeholder="Enter percentage"
              inputProps={{ min: 0, max: 100 }}
              value={current || ""}
              onChange={(e) =>
                handleChangepercentage(user.id, Number(e.target.value))
              }
            />
          </Grid>
        );
      })}

      </Grid>
          </Grid>

          <Grid item xs={12}                                      >
         

            <Grid container gap={2} mt={2} justifyContent="flex-end">
              <Button
                variant="contained"
                color="error"
                //   size="small"

                onClick={onClose}
                startIcon={<ClearIcon fontSize="small" />}
                sx={{ borderRadius: "5px" }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                //   size="small"
                   onClick={handleSubmit}
                endIcon={<ArrowForwardIcon fontSize="small" />}
                sx={{ borderRadius: "5px" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
    

      {/* Popup */}
      {/* {assignTo.length > 1 && (
        <CustomPopup
          open={openPopup}
          onClose={handleClosePopup}
          title="Assign Percentage Distribution"
          component={
            <AssignPerCentageForm
              assignTo={assignTo}
              percentages={percentages}
              handleChangepercentage={handleChangepercentage}
                 onClose={handleClosePopup}
            />
          }
          maxWidth="xs"
          showDivider={true}
        />
      )} */}


      <CustomSnackbar
              open={snackbarOpen}
              onClose={() => setSnackbarOpen(false)}
              message={snackbarMessage}
              severity={snackbarSeverity}
            />
    </>
  );
}
